import { useTypedQuery } from "hooks";
import { BrandsDashboardQueryKeys } from "modules/BrandsDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

import type { Brand } from "models";

const sortBrandsByGroupAndName = (brands: Brand[]) =>
  [...brands].sort((a, b) => (a.brand_group_name ?? "").localeCompare(b.brand_group_name ?? "") || a.name.localeCompare(b.name));

export const useBrandsQuery = () =>
  useTypedQuery({
    queryKey: BrandsDashboardQueryKeys.brands,
    queryFn: async ({ baseUrl, endpoint }) => (await ApiInstance.post(endpoint, {}, baseUrl)).data.brands,
    select: sortBrandsByGroupAndName
  });
